import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "InfoRequest",
  class: "inforequest inner"
}
const _hoisted_2 = {
  key: 0,
  class: "request"
}
const _hoisted_3 = {
  key: 0,
  class: "formimage"
}
const _hoisted_4 = {
  class: "form",
  "data-request": ""
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "maintitle s36" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = { for: "NameSurname" }
const _hoisted_9 = { class: "group" }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = { for: "Phone" }
const _hoisted_12 = ["aria-label", "placeholder"]
const _hoisted_13 = { class: "item" }
const _hoisted_14 = ["aria-label", "placeholder"]
const _hoisted_15 = { class: "item" }
const _hoisted_16 = { for: "Zone" }
const _hoisted_17 = { value: null }
const _hoisted_18 = ["value"]
const _hoisted_19 = ["aria-label"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "item" }
const _hoisted_22 = { for: "Company" }
const _hoisted_23 = ["aria-label"]
const _hoisted_24 = { class: "item" }
const _hoisted_25 = { for: "Profession" }
const _hoisted_26 = ["aria-label"]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "checkbox" }
const _hoisted_29 = { for: "IsAddress" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { class: "group" }
const _hoisted_32 = { class: "item" }
const _hoisted_33 = { for: "Address" }
const _hoisted_34 = ["aria-label", "placeholder"]
const _hoisted_35 = { class: "item" }
const _hoisted_36 = ["aria-label", "placeholder"]
const _hoisted_37 = { class: "item" }
const _hoisted_38 = { for: "Location" }
const _hoisted_39 = ["aria-label"]
const _hoisted_40 = ["disabled"]
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = {
  key: 0,
  class: "validation-summary-errors"
}
const _hoisted_43 = { class: "cta" }
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = ["alt"]
const _hoisted_46 = {
  key: 1,
  class: "confirm"
}
const _hoisted_47 = { class: "maintitle s60" }
const _hoisted_48 = { class: "cta s16 secondary" }
const _hoisted_49 = ["href"]

import { ref, onBeforeMount } from "vue";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoRequest',
  props: {
    recaptchaSiteKey: {},
    landingPageSlug: {},
    landingName: {},
    isCompany: { type: Boolean },
    isAddress: { type: Boolean },
    addressLabel: {},
    titleForm: {},
    language: {}
  },
  setup(__props: any) {

const props = __props;

const localizer = Localizer;
const routes = (window as any).App.routes;
const titleForm = ref(localizer.get("LandingPage.InfoRequest.Title"));

const isLoading = ref(true);
const isLoadingForm = ref(false);
const isSuccess = ref(false);
const formData = ref<any>({ zone: null, isCompany: false, isAddress: false });
const zones = ref<any[]>([]);
const validationErrors = ref<any[]>([]);

onBeforeMount(async () => {
    await getData();

    titleForm.value = props.titleForm ? props.titleForm : titleForm.value;
});

async function getData() {
    const response = (await Axios.post(routes.LandingPage_LandingPage_GetSubscribeData)).data;
    zones.value = response.zones;
    isLoading.value = false;
}

async function submitForm() {
    FormHelper.removeFocus();

    validationErrors.value = [];
    isLoadingForm.value = true;
    formData.value.landingPageSlug = props.landingPageSlug;
    formData.value.isCompany = props.isCompany;

    (window as any).grecaptcha.enterprise.ready(async () => {
        const token = await (window as any).grecaptcha.enterprise.execute(props.recaptchaSiteKey, { action: "Submit" });
        try {
            await Axios.post(routes.LandingPage_LandingPage_Submit, formData.value, { headers: { RecaptchaVerificationToken: token } });
            isSuccess.value = true;
            GTagHelper.sendEvent("form_submit", "landing_info_request", props.landingName);
        } catch (error: any) {
            if (error.response && error.response.status === 400) {
                validationErrors.value = FormHelper.getValidationErrors(error.response.data);
            }
        }

        isLoadingForm.value = false;
    });
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isSuccess.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("fieldset", { disabled: isLoadingForm.value }, [
                    _createElementVNode("h3", _hoisted_6, _toDisplayString(titleForm.value), 1),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.NameSurname")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "NameSurname",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.nameSurname) = $event)),
                        class: _normalizeClass([{ 'input-validation-error': isValidationError('NameSurname') }, 'input w300'])
                      }, null, 2), [
                        [
                          _vModelText,
                          formData.value.nameSurname,
                          void 0,
                          { lazy: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.PhoneEmail")), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "tel",
                          "aria-label": _unref(localizer).get('LandingPage.InfoRequest.Phone'),
                          id: "Phone",
                          placeholder: _unref(localizer).get('LandingPage.InfoRequest.PhonePlaceholder'),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.phone) = $event)),
                          class: _normalizeClass([{ 'input-validation-error': isValidationError('Phone') }, 'input w300'])
                        }, null, 10, _hoisted_12), [
                          [
                            _vModelText,
                            formData.value.phone,
                            void 0,
                            { lazy: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          "aria-label": _unref(localizer).get('LandingPage.InfoRequest.Email'),
                          id: "Email",
                          placeholder: _unref(localizer).get('LandingPage.InfoRequest.EmailPlaceholder'),
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.email) = $event)),
                          class: _normalizeClass([{ 'input-validation-error': isValidationError('Email') }, 'input w300'])
                        }, null, 10, _hoisted_14), [
                          [
                            _vModelText,
                            formData.value.email,
                            void 0,
                            { lazy: true }
                          ]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.Zone")), 1),
                      (__props.language === 'it')
                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                            key: 0,
                            id: "Zone",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.zone) = $event)),
                            class: _normalizeClass([{ 'input-validation-error': isValidationError('Zone') }, 'input w300'])
                          }, [
                            _createElementVNode("option", _hoisted_17, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.Select")), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zones.value, (item, index) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: item.value,
                                key: index
                              }, _toDisplayString(item.title), 9, _hoisted_18))
                            }), 128))
                          ], 2)), [
                            [
                              _vModelSelect,
                              formData.value.zone,
                              void 0,
                              { lazy: true }
                            ]
                          ])
                        : _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 1,
                            type: "text",
                            "aria-label": _unref(localizer).get('LandingPage.InfoRequest.Zone'),
                            id: "Zone",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.zone) = $event)),
                            class: _normalizeClass([{ 'input-validation-error': isValidationError('Zone') }, 'input w300'])
                          }, null, 10, _hoisted_19)), [
                            [
                              _vModelText,
                              formData.value.zone,
                              void 0,
                              { lazy: true }
                            ]
                          ])
                    ])
                  ], 8, _hoisted_5),
                  (__props.isCompany)
                    ? (_openBlock(), _createElementBlock("fieldset", {
                        key: 0,
                        disabled: isLoadingForm.value
                      }, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.Company")), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "aria-label": _unref(localizer).get('LandingPage.InfoRequest.Company'),
                            id: "Company",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.company) = $event)),
                            class: _normalizeClass([{ 'input-validation-error': isValidationError('Company') }, 'input w300'])
                          }, null, 10, _hoisted_23), [
                            [
                              _vModelText,
                              formData.value.company,
                              void 0,
                              { lazy: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("label", _hoisted_25, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.Profession")), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "aria-label": _unref(localizer).get('LandingPage.InfoRequest.Profession'),
                            id: "Profession",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.profession) = $event)),
                            class: _normalizeClass([{ 'input-validation-error': isValidationError('Profession') }, 'input w300'])
                          }, null, 10, _hoisted_26), [
                            [
                              _vModelText,
                              formData.value.profession,
                              void 0,
                              { lazy: true }
                            ]
                          ])
                        ])
                      ], 8, _hoisted_20))
                    : _createCommentVNode("", true),
                  (__props.isAddress)
                    ? (_openBlock(), _createElementBlock("fieldset", {
                        key: 1,
                        disabled: isLoadingForm.value
                      }, [
                        _createElementVNode("div", _hoisted_28, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: "IsAddress",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.isAddress) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, formData.value.isAddress]
                          ]),
                          _createElementVNode("label", _hoisted_29, _toDisplayString(__props.addressLabel), 1)
                        ])
                      ], 8, _hoisted_27))
                    : _createCommentVNode("", true),
                  (formData.value.isAddress)
                    ? (_openBlock(), _createElementBlock("fieldset", {
                        key: 2,
                        disabled: isLoadingForm.value
                      }, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("label", _hoisted_33, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.Address")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "aria-label": _unref(localizer).get('LandingPage.InfoRequest.Address'),
                              placeholder: _unref(localizer).get('LandingPage.InfoRequest.Address'),
                              id: "Address",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.address) = $event)),
                              class: _normalizeClass([{ 'input-validation-error': isValidationError('Address') }, 'input w300'])
                            }, null, 10, _hoisted_34), [
                              [
                                _vModelText,
                                formData.value.address,
                                void 0,
                                { lazy: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "aria-label": _unref(localizer).get('LandingPage.InfoRequest.PostCode'),
                              placeholder: _unref(localizer).get('LandingPage.InfoRequest.PostCode'),
                              id: "PostCode",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.postCode) = $event)),
                              class: _normalizeClass([{ 'input-validation-error': isValidationError('PostCode') }, 'input w160'])
                            }, null, 10, _hoisted_36), [
                              [
                                _vModelText,
                                formData.value.postCode,
                                void 0,
                                { lazy: true }
                              ]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("label", _hoisted_38, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.Location")), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "aria-label": _unref(localizer).get('LandingPage.InfoRequest.Location'),
                            id: "Location",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.location) = $event)),
                            class: _normalizeClass([{ 'input-validation-error': isValidationError('Location') }, 'input w300'])
                          }, null, 10, _hoisted_39), [
                            [
                              _vModelText,
                              formData.value.location,
                              void 0,
                              { lazy: true }
                            ]
                          ])
                        ])
                      ], 8, _hoisted_30))
                    : _createCommentVNode("", true),
                  _createElementVNode("fieldset", { disabled: isLoadingForm.value }, [
                    _createElementVNode("div", {
                      class: "desc small",
                      innerHTML: _unref(localizer).get('LandingPage.InfoRequest.PrivacyPolicy', _unref(routes).UrlPrivacyPolicy)
                    }, null, 8, _hoisted_41),
                    (validationErrors.value.length !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(validationError.message), 1))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("button", {
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (submitForm())),
                        class: _normalizeClass([{ 'loading': isLoadingForm.value }, 'button'])
                      }, [
                        (!isLoadingForm.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.SendRequest")), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 2)
                    ])
                  ], 8, _hoisted_40),
                  _createElementVNode("div", {
                    class: "desc small grecaptcha-terms",
                    innerHTML: _unref(localizer).get('LandingPage.Support.Captcha_Terms')
                  }, null, 8, _hoisted_44)
                ]),
                _createElementVNode("img", {
                  src: "/images/support.webp",
                  width: "620",
                  height: "772",
                  alt: __props.addressLabel,
                  class: "support-image"
                }, null, 8, _hoisted_45)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.FormSuccessTitle")), 1),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("a", {
              href: _unref(routes).Home,
              class: "button"
            }, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.ContinueBrowsing")), 9, _hoisted_49)
          ])
        ]))
  ]))
}
}

})